import { ComponentType, PropsWithChildren } from 'react';

import { FallbackProps } from 'react-error-boundary';

import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

import { logout } from 'src/api';
import { iframeAuthService } from 'src/api/iframeAuth';
import { ClientErrorCode, ClientError } from 'src/utils/clientError';

import ErrorPanel from './ErrorPanel';

export const GlobalErrorFallback: ComponentType<
  PropsWithChildren<FallbackProps>
> = ({ error }) => {
  // TODO: Make an error log

  const clientError = error as ClientError;
  const isInIframe = iframeAuthService.isInIframe();
  const isAuthError = [
    ClientErrorCode.UNAUTHORIZED,
    ClientErrorCode.UNAUTHENTICATED,
  ].includes(clientError?.code);

  // For iframe mode with authentication errors, show retry message
  if (isInIframe && clientError?.code === ClientErrorCode.UNAUTHENTICATED) {
    return (
      <Container>
        <ErrorPanel
          title="Authentication Expired"
          subTitle2="Retrying authentication... Please wait."
        >
          <Message>
            If this issue persists, please refresh the parent page.
          </Message>
        </ErrorPanel>
      </Container>
    );
  }

  return (
    <Container>
      <ErrorPanel title={error.name} subTitle2={error.message}>
        {isAuthError ? (
          <Button
            variant="contained"
            color="primary"
            aria-label="logout"
            onClick={logout}
          >
            Go back to login page
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            aria-label="home"
            href="/"
          >
            Go back to home
          </Button>
        )}
      </ErrorPanel>
    </Container>
  );
};

const Container = styled('div')`
  padding: 3rem;
  margin: auto;
`;

const Message = styled('div')`
  margin-top: 1rem;
  color: #666;
  font-size: 0.875rem;
  text-align: center;
`;
